import { get } from 'lodash';

export const typeEnum = [
  { id: 'ISSUE', label: 'výdejka' },
  { id: 'DISPOSAL', label: 'likvidační protokol' },
  { id: 'PROCUREMENT', label: 'dodejka' },
  { id: 'TRANSFER', label: 'převodka' },
  { id: 'RECEIPT', label: 'příjemka' }
];

export const protocolCreateFormEnum = {
  DISPOSAL: {
    id: 'disposal',
    label: 'Vytvořit likvidační protokol',
    firstAutocompleteField: {
      id: 'warehouse',
      name: 'warehouse',
      label: 'Sklad',
      url: '/metropolis/api/wa/warehouses',
      filterActive: true,
      labelFunction: o => get(o, 'name')
    },
    secondAutocompleteField: {
      id: 'disposalType',
      name: 'disposalType',
      label: 'Typ likvidace',
      url: '/metropolis/api/wa/disposal-types',
      labelFunction: o => get(o, 'name')
    },
    warehouseLabel: 'sklad',
    sequenceKey: 'sequenceProtocolDisposal'
  },

  ISSUE: {
    id: 'issue',
    label: 'Vytvořit výdejku',
    firstAutocompleteField: {
      name: 'warehouse',
      id: 'warehouse',
      label: 'Sklad',
      url: '/metropolis/api/wa/warehouses',
      filterActive: true,
      labelFunction: o => get(o, 'name')
    },
    secondAutocompleteField: {
      id: 'employee',
      name: 'employee',
      label: 'Přijal',
      url: '/metropolis/api/hr/employees',
      labelFunction: o => get(o, 'fullName')
    },
    sequenceKey: 'sequenceProtocolIssue'
  },

  PROCUREMENT: {
    id: 'procurement',
    label: 'Vytvořit dodejku',
    firstAutocompleteField: {
      id: 'warehouse',
      name: 'warehouse',
      label: 'Sklad',
      url: '/metropolis/api/wa/warehouses',
      filterActive: true,
      labelFunction: o => get(o, 'name')
    },
    secondAutocompleteField: {
      id: 'supplier',
      name: 'supplier',
      label: 'Dodavatel',
      url: '/metropolis/api/wa/suppliers',
      filterActive: true,
      labelFunction: o => get(o, 'name')
    },
    sequenceKey: 'sequenceProtocolProcurement'
  },

  TRANSFER: {
    id: 'transfer',
    label: 'Vytvořit převodku',
    firstAutocompleteField: {
      id: 'warehouse',
      name: 'warehouse',
      label: 'Zdrojový sklad',
      url: '/metropolis/api/wa/warehouses',
      filterActive: true,
      labelFunction: o => get(o, 'name')
    },
    secondAutocompleteField: {
      id: 'destinationWarehouse',
      name: 'destinationWarehouse',
      label: 'Cílový sklad',
      url: '/metropolis/api/wa/warehouses',
      filterActive: true,
      labelFunction: o => get(o, 'name')
    },
    sequenceKey: 'sequenceProtocolTransfer'
  },

  RECEIPT: {
    id: 'receipt',
    label: 'Vytvořit příjemku',
    firstAutocompleteField: {
      id: 'warehouse',
      name: 'warehouse',
      label: 'Sklad',
      url: '/metropolis/api/wa/warehouses',
      filterActive: true,
      labelFunction: o => get(o, 'name')
    },
    secondAutocompleteField: {
      id: 'employee',
      name: 'employee',
      label: 'Odevzdal',
      url: '/metropolis/api/hr/employees',
      labelFunction: o => get(o, 'fullName')
    },
    sequenceKey: 'sequenceProtocolReceipt'
  }
};



// WEBPACK FOOTER //
// ./src/modules/protocols/_protocolsEnums.ts